// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1-gks","messages":"Chat_messages__2KBn3","dateDivider":"Chat_dateDivider__1i406"};